import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

// @material-ui/icons

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardFooter from 'components/Card/CardFooter.jsx'

import teamStyle from 'assets/jss/material-kit-react/views/landingPageSections/teamStyle.jsx'

import team1 from 'assets/img/faces/zach.jpg'
import team2 from 'assets/img/faces/anna.jpg'

class TeamSection extends React.Component {
    render() {
        const { classes } = this.props
        const imageClasses = classNames(
            classes.imgRaised,
            classes.imgRoundedCircle,
            classes.imgFluid
        )
        return (
            <div className={classes.section}>
                <h2 className={classes.title}>Leadership</h2>
                <div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <Card plain>
                                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                                    <img src={team1} alt="..." className={imageClasses} />
                                </GridItem>
                                <h4 className={classes.cardTitle}>
                  Zach Probst
                                    <br />
                                    <small className={classes.smallTitle}>
                    Chief Executive Officer
                                    </small>
                                </h4>
                                <CardBody>
                                    <p className={classes.description}>
                    Educated in Computer Science, Computing Security, and
                    Entrepreneurship at the{' '}
                                        <a href="https://www.rit.edu/">
                      Rochester Institute of Technology
                                        </a>
                    , Zach is our CEO and technical lead. Under his guidance, we
                    have began to innovate in a complex field.
                                    </p>
                                </CardBody>
                                <CardFooter className={classes.justifyCenter}>
                                    <Button
                                        href="https://www.linkedin.com/in/zach-probst/"
                                        justIcon
                                        color="transparent"
                                        className={classes.margin5}
                                    >
                                        <i className={classes.socials + ' fab fa-linkedin'} />
                                    </Button>
                                </CardFooter>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <Card plain>
                                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                                    <img src={team2} alt="..." className={imageClasses} />
                                </GridItem>
                                <h4 className={classes.cardTitle}>
                  Anna Capria
                                    <br />
                                    <small className={classes.smallTitle}>
                    Chief Customer Success Officer
                                    </small>
                                </h4>
                                <CardBody>
                                    <p className={classes.description}>
                    Anna is responsible for ensuring the success of our
                    customers by thoughtfully listening to their needs. Under
                    her guidance, we have pivoted and learned a great deal from
                    our customers in our quest to innovate.
                                    </p>
                                </CardBody>
                                <CardFooter className={classes.justifyCenter}>
                                    <Button
                                        href="https://www.linkedin.com/in/anna-capria-a83933129/"
                                        justIcon
                                        color="transparent"
                                        className={classes.margin5}
                                    >
                                        <i className={classes.socials + ' fab fa-linkedin'} />
                                    </Button>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        )
    }
}

export default withStyles(teamStyle)(TeamSection)



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/TeamSection.jsx